import React, { useState } from "react";

//boostrap
import { Container, Row, Col, Button } from "reactstrap";

//components
import { DragDropZoneFile } from "@ui-partents/Form/FormUpload";
import { PdfContent, ProposalTemplate } from "../reliProposal";

//api
import { apiCaller } from "@utils";

function PdfUpload(props) {

    //pagination
    const [isShow, setShow] = useState(false);
    const [uploadData, setUploadData] = useState(null); //files
    const [stateData, setData] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const [stateProposalTemplate, setProposalTemplate] = useState("");

    // Upload File
    const handleUpload = (data) => {
        //Set Image Preview
        data.map((file) => setUploadData(URL.createObjectURL(file)));

        //Set File FormData
        data.map((file) => setUploadData(file));
    };

    // Handle Submit Upload
    const handleSubmit = () => {
        setLoading(true);
        const formData = new FormData();
        formData.append("pdf", uploadData);
        formData.append("action_type", "proposal_pipeline");
        formData.append("model", "gpt-3.5-turbo");
        formData.append("min_bullets", 12);
        formData.append("skip_first_pages", 3);
        formData.append("proposal_template", stateProposalTemplate);

        //Call Api
        apiCaller(`/api/binh/reli/`, "POST", formData).then((res) => {
            if (res?.status === 200) {
                const data = res?.data?.message;
                //set State
                setData(data);
                setLoading(false);

                //Clear du lieu da upload
                setUploadData(null);
                setShow(true);
            } else {
                console.log("error");
                setLoading(false);
            }
        });
    }

    return (
        <React.Fragment>
            {!isShow && (
                <Container className="-box-shadow bg-white p-4 mt-5">
                    <Row>
                        <Col md={6}>
                            <ProposalTemplate
                                {...props}
                                stateProposalTemplate={stateProposalTemplate}
                                handleProposalTemplate={(e) => { setProposalTemplate(e.target.value) }}
                            />
                        </Col>
                        <Col md={6}>
                            <DragDropZoneFile
                                onChange={handleUpload}
                                acceptFile="application/pdf"
                                value={""}
                            />
                            <div className="text-center">
                                <Button
                                    color="primary"
                                    className="btn btn-primary mt-3 ml-auto"
                                    onClick={handleSubmit}
                                    disabled={uploadData ? false : true}
                                >
                                    {isLoading && <span className="spinner-border spinner-border-sm mr-2"></span>}
                                    Upload
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            )}
            {isShow && (
                <PdfContent
                    {...props}
                    rowData={stateData}
                />
            )}
        </React.Fragment>
    );
}

export default PdfUpload;